// @flow

// TODO: use https://github.com/realadvisor/realadvisor/tree/master/packages/cloudinary

export const cloudinaryUrl = (options: any, url: string) => {
  return url;
};

export default cloudinaryUrl;
